<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
      <div class="date-wrapper">
        <FilterChipButtons
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
        />
      </div>
      <v-skeleton-loader
				v-if="boothStaffLoading"
				v-bind="attrs"
				max-width="555"
				width="100%"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">


        <div v-if="filterModalIsVisible">
          <FilterModal
              :filterModalIsVisible="filterModalIsVisible"
              :currentModalFilter="currentModalFilter"
              :currentModalLabel="currentModalLabel"
              :selectedChips="selectedChips"
              :filters="filters"
              :dateError="date.error"
              :dateOption="date.option"
              :dateRange="date.selectedRange"
              @closeModal="closeModal"
              @applySelection="applySelection"
              @setItem="setItem"
          />
        </div>
				<div class="boothStaff">
					<div v-for="(boothStaff, index) in boothStaffList" :key="index">
						<router-link
							:to="{
								name: isCurrentUser(boothStaff.user_id) ? 'my-account' : 'user-by-id',
								query: { event: $route.query.event },
								params: isCurrentUser(boothStaff.user_id)
									? []
									: { id: boothStaff.user_id },
							}"
							class="text-decoration-none"
						>
							<BoothStaffCard @handleTriggerToBoothStaff="handleTriggerToBoothStaff" :boothStaff="boothStaff" backgroundColor="#fff" />
						</router-link>
					</div>
				</div>

				<div
					v-if="!boothStaffLoading && boothStaffList.length > 0"
					class="d-flex my-9 justify-center home-page__pagination"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.pageCountBoothStaff"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import ButtonBack from '@/components/ButtonBack'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import BoothStaffCard from '@/components/Event/BoothStaffCard.vue'
import Dwh from '@/mixins/Dwh'
import FilterChipButtons from "@/components/FilterChipButtons.vue";

export default {
	name: 'BoothStaffPage',
	mixins: [Block, Filter, Dwh],
	components: {
    FilterChipButtons,
		BoothStaffCard,
		FilterModal,
		FilterChipButton,
		PageBlocked,
		Pagination,
		ButtonBack,
	},

	methods: {
		...mapActions('event', ['getBoothStaff']),
		...mapActions('app', ['setPageTitle']),
    handleTriggerToBoothStaff(userName,userId){
      this.sendTrigger({
        category: 'Booth Staff',
        action: 'click_booth_staff_profile_preview',
        module: 'Events',
        title: userName,
        id1: userId,
        id2: this.$route.query.event,
      })
    },
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const { user_id: currentUserId } = this.profile
			return userId === currentUserId
		},
    viewBoothStaffListTrigger(){
      this.sendTrigger({
        category: 'Booth Staff',
        action: 'view_booth_staff_list',
        module: 'Events',
        title: this.$route.query.name,
        id1: this.$route.params.id,
        id2: this.$route.query.event,
      })
    },
	},
	mounted() {
		this.setPageTitle('Booth Staff')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
      this.viewBoothStaffListTrigger()
			this.getBoothStaff(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('event', ['boothStaffLoading', 'boothStaffList', 'pageCountBoothStaff']),
		...mapGetters('auth', ['profile']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss"></style>
